<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10.71,7.29C10.71,7.29,6.71,3.29,6.71,3.29C6.53,3.11,6.28,3,6,3C5.45,3,5,3.45,5,4C5,4.28,5.11,4.53,5.29,4.71C5.29,4.71,8.59,8,8.59,8C8.59,8,5.3,11.29,5.3,11.29C5.11,11.47,5,11.72,5,12C5,12.55,5.45,13,6,13C6.28,13,6.53,12.89,6.71,12.71C6.71,12.71,10.71,8.71,10.71,8.71C10.89,8.530000000000001,11,8.280000000000001,11,8C11,7.72,10.89,7.47,10.71,7.29C10.71,7.29,10.71,7.29,10.71,7.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ChevronRight',
} as DefineComponent
</script>
